<script setup>
// BonBoZ: chọn ảnh cho một mẫu trả lời.
//
// Mẫu chỉ giữ ID ảnh trong kho marketing, không giữ bản sao — xem migration
// `20260916000011_add_anh_ids_to_canned_responses.rb`. Vì thế ô này không có
// nút tải tệp riêng: tải ảnh lên là việc của kho ảnh, ở đây chỉ trỏ tới.
//
// Kho ảnh là MỘT kho chung cho mọi trang, nên không phải chọn trang trước.
// Server trả kèm URL ảnh của mẫu (`CannedResponsesController#kem_anh`), nên gửi
// mẫu từ trang nào cũng đủ ảnh.
import { ref, computed } from 'vue';
import KhoAnh from 'dashboard/components/widgets/conversation/bonboz/KhoAnh.vue';

const props = defineProps({
  // Anh da gan san (server tra kem mau) — de hien thu nho khi sua mau.
  anh: { type: Array, default: () => [] },
});
const ids = defineModel({ type: Array, default: () => [] });

const hienKho = ref(false);
// id -> anh da biet URL: anh san co cua mau + anh vua chon trong kho.
const daBiet = ref(new Map(props.anh.map(a => [Number(a.id), a])));

const anhCuaMau = computed(() =>
  ids.value.map(id => daBiet.value.get(Number(id))).filter(Boolean)
);

const themAnh = dsMoi => {
  dsMoi.forEach(a => daBiet.value.set(Number(a.id), a));
  const co = new Set(ids.value.map(Number));
  ids.value = [
    ...ids.value,
    ...dsMoi.map(a => a.id).filter(id => !co.has(Number(id))),
  ];
};

const boAnh = id => {
  ids.value = ids.value.filter(x => Number(x) !== Number(id));
};

// Id con trong mau ma khong ai biet URL = anh da bi xoa khoi kho.
const soMat = computed(() => ids.value.length - anhCuaMau.value.length);
const boAnhMat = () => {
  ids.value = anhCuaMau.value.map(a => a.id);
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <div v-if="anhCuaMau.length" class="flex gap-1.5 overflow-x-auto pb-1">
      <div
        v-for="a in anhCuaMau"
        :key="a.id"
        v-tooltip.top="a.ten"
        class="relative flex-shrink-0 w-16 h-16 overflow-hidden border rounded-lg group border-n-weak bg-n-alpha-1"
      >
        <video
          v-if="a.loai === 'video'"
          :src="a.url"
          preload="metadata"
          muted
          playsinline
          class="object-cover w-full h-full"
        />
        <img
          v-else
          :src="a.url"
          :alt="a.ten"
          class="object-cover w-full h-full"
        />
        <span
          v-if="a.loai === 'video'"
          class="absolute inset-0 grid pointer-events-none place-items-center"
        >
          <span
            class="grid text-white rounded-full size-6 place-items-center bg-[rgb(0_0_0/0.55)]"
          >
            <span class="i-lucide-play size-3.5" />
          </span>
        </span>
        <button
          type="button"
          :aria-label="$t('BONBOZ.MAU_ANH.BO')"
          class="absolute flex items-center justify-center w-5 h-5 text-white transition-opacity rounded-full opacity-0 top-1 right-1 bg-[rgb(0_0_0/0.6)] hover:bg-[rgb(0_0_0/0.8)] group-hover:opacity-100 focus:opacity-100"
          @click="boAnh(a.id)"
        >
          <svg
            viewBox="0 0 10 10"
            width="10"
            height="10"
            class="shrink-0"
            aria-hidden="true"
          >
            <path
              d="M1 1 L9 9 M9 1 L1 9"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              fill="none"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <button
        type="button"
        class="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-md bg-n-alpha-2 text-n-slate-11 hover:bg-n-alpha-3 disabled:opacity-50"
        @click="hienKho = true"
      >
        <span class="i-lucide-images size-3.5" />
        {{ $t('BONBOZ.MAU_ANH.CHON') }}
      </button>
    </div>
    <!-- Anh cua mau da bi xoa khoi kho van con ID trong mau: bo qua tam do chu
         khong bao loi — mot mau thieu anh van dung duoc. -->
    <p v-if="soMat" class="text-xs text-n-ruby-11">
      {{ $t('BONBOZ.MAU_ANH.MAT_ANH', { so: soMat }) }}
      <button type="button" class="underline" @click="boAnhMat">
        {{ $t('BONBOZ.MAU_ANH.BO') }}
      </button>
    </p>
    <KhoAnh v-if="hienKho" v-model:show="hienKho" tra-ve-id @chon="themAnh" />
  </div>
</template>
